import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime-corejs2/regenerator";
import _defineProperty from "/app/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import "core-js/modules/es6.number.constructor";
import _slicedToArray from "/app/node_modules/@babel/runtime-corejs2/helpers/slicedToArray";
import "core-js/modules/es6.regexp.split";
import "regenerator-runtime/runtime";
import _toConsumableArray from "/app/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { deepClone } from '@/modules/mm-utils';
import { API_REQUEST } from '@/api/';
export default function (_x, _x2) {
  return _ref3.apply(this, arguments);
}

function _ref3() {
  _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref, _ref2) {
    var _destination$, _source$;

    var state, rootGetters, rootState, commit, dispatch, source, destination, tableCellParts, daysWithData, daysWithoutData, workerDayIds, _getSplitedToDates, toClearDates, toChangeDates, toWorkerEmplId, fromWorkerEmplId, changedDays, result, currentDepId, toDates, fromDates, _yield$API_REQUEST, _yield$API_REQUEST2, error, response, _daysWithData, daysWithDataCopy, _iterator, _step, day, _yield$API_REQUEST3, _yield$API_REQUEST4, _error, _response, cellId;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            state = _ref.state, rootGetters = _ref.rootGetters, rootState = _ref.rootState, commit = _ref.commit, dispatch = _ref.dispatch;
            source = _ref2.source, destination = _ref2.destination;
            commit('setIsLoading', true);
            tableCellParts = state.tableCellParts;
            daysWithData = 0;
            daysWithoutData = 0;
            workerDayIds = source.reduce(function (acc, fromDate) {
              var workerDay = state.workerDays[0] && state.workerDays[0][fromDate] || undefined;

              if ((!workerDay || workerDay['type'] === 'E') && tableCellParts[0] === 'PLAN_UNAPPR' && tableCellParts[1] === 'PLAN_APPR') {
                workerDay = state.workerDays[1] && state.workerDays[1][fromDate] || undefined;
              }

              if (workerDay) {
                acc.push(workerDay['id']);
                daysWithData++;
              } else {
                daysWithoutData++;
              }

              return acc;
            }, []);
            _getSplitedToDates = getSplitedToDates(daysWithData, daysWithoutData, destination), toClearDates = _getSplitedToDates.toClearDates, toChangeDates = _getSplitedToDates.toChangeDates;
            toWorkerEmplId = +((_destination$ = destination[0]) === null || _destination$ === void 0 ? void 0 : _destination$.split('_')[1]);
            fromWorkerEmplId = +((_source$ = source[0]) === null || _source$ === void 0 ? void 0 : _source$.split('_')[1]);
            _context.prev = 10;

            if (!hasProtectedIntegrationShift({
              state: state,
              rootState: rootState,
              cellIds: [].concat(_toConsumableArray(source), _toConsumableArray(destination))
            })) {
              _context.next = 13;
              break;
            }

            return _context.abrupt("return", {
              reason: 'integration-day-protected'
            });

          case 13:
            changedDays = {};
            result = [];
            currentDepId = rootGetters['queryMirrored/getOneDep'];

            if (!toChangeDates.length) {
              _context.next = 28;
              break;
            }

            toDates = toChangeDates.map(function (_) {
              return _.split('_')[0];
            });
            fromDates = source.map(function (_) {
              return _.split('_')[0];
            });
            _context.next = 21;
            return API_REQUEST('duplicateWorkerDays', {
              'to_employee_id': toWorkerEmplId,
              'from_employee_id': fromWorkerEmplId,
              'from_workerday_ids': workerDayIds,
              'from_dates': fromDates,
              'to_dates': toDates
            });

          case 21:
            _yield$API_REQUEST = _context.sent;
            _yield$API_REQUEST2 = _slicedToArray(_yield$API_REQUEST, 2);
            error = _yield$API_REQUEST2[0];
            response = _yield$API_REQUEST2[1];

            if (!error) {
              _context.next = 27;
              break;
            }

            throw new Error('duplicateWorkerDays fails');

          case 27:
            result = response;

          case 28:
            if (!toClearDates.length) {
              _context.next = 63;
              break;
            }

            _daysWithData = [];
            toClearDates.forEach(function (day) {
              if (state.workerDays[0] && state.workerDays[0][day]) {
                _daysWithData.push(state.workerDays[0][day]);
              }
            });
            daysWithDataCopy = deepClone(_daysWithData);
            _iterator = _createForOfIteratorHelper(daysWithDataCopy);
            _context.prev = 33;

            _iterator.s();

          case 35:
            if ((_step = _iterator.n()).done) {
              _context.next = 55;
              break;
            }

            day = _step.value;
            day.type = 'E';
            delete day['dttm_work_start'];
            delete day['dttm_work_end'];
            delete day['work_type_id'];
            delete day['parent_worker_day_id'];
            delete day['work_hours'];
            delete day.isAnotherDep;
            delete day.shifts;
            delete day.shiftCount;
            _context.next = 48;
            return API_REQUEST('updateWorkerDay', day);

          case 48:
            _yield$API_REQUEST3 = _context.sent;
            _yield$API_REQUEST4 = _slicedToArray(_yield$API_REQUEST3, 2);
            _error = _yield$API_REQUEST4[0];
            _response = _yield$API_REQUEST4[1];

            if (!_error) {
              result.push(_response);
            }

          case 53:
            _context.next = 35;
            break;

          case 55:
            _context.next = 60;
            break;

          case 57:
            _context.prev = 57;
            _context.t0 = _context["catch"](33);

            _iterator.e(_context.t0);

          case 60:
            _context.prev = 60;

            _iterator.f();

            return _context.finish(60);

          case 63:
            if (result.length) {
              _context.next = 65;
              break;
            }

            return _context.abrupt("return", false);

          case 65:
            result.forEach(function (day) {
              var cellId = "".concat(day.dt, "_").concat(day.employee_id);
              var dayDetails = day['worker_day_details'];

              if (dayDetails !== null && dayDetails !== void 0 && dayDetails.length) {
                day['work_type_id'] = dayDetails[0]['work_type_id'];
              }

              day.isAnotherDep = day.type === 'W' && day.shop_id !== Number(currentDepId);

              if (!changedDays[cellId]) {
                changedDays[cellId] = _objectSpread(_objectSpread({}, day), {}, {
                  shifts: [day],
                  shiftCount: 1
                });
              } else {
                changedDays[cellId].shifts.push(day);
                changedDays[cellId].shiftCount++;
              }
            });

            for (cellId in changedDays) {
              commit('changeDay', {
                cellId: cellId,
                changedDay: changedDays[cellId]
              });
            }

            _context.next = 69;
            return dispatch('updateWorkerStats', {});

          case 69:
            dispatch('applyTableView', {});
            return _context.abrupt("return", true);

          case 73:
            _context.prev = 73;
            _context.t1 = _context["catch"](10);
            return _context.abrupt("return", false);

          case 76:
            _context.prev = 76;
            commit('setIsLoading', false);
            return _context.finish(76);

          case 79:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[10, 73, 76, 79], [33, 57, 60, 63]]);
  }));
  return _ref3.apply(this, arguments);
}

function hasProtectedIntegrationShift(_ref4) {
  var _rootState$user$data$;

  var state = _ref4.state,
      rootState = _ref4.rootState,
      cellIds = _ref4.cellIds;

  if (!((_rootState$user$data$ = rootState.user.data.network) !== null && _rootState$user$data$ !== void 0 && _rootState$user$data$.forbid_edit_work_days_came_through_integration)) {
    return false;
  }

  return cellIds.some(function (cellId) {
    return [0, 1].some(function (partIndex) {
      var _state$workerDays$par, _workerDay$shifts;

      var workerDay = (_state$workerDays$par = state.workerDays[partIndex]) === null || _state$workerDays$par === void 0 ? void 0 : _state$workerDays$par[cellId];
      return !!(workerDay !== null && workerDay !== void 0 && workerDay.code) || (workerDay === null || workerDay === void 0 ? void 0 : (_workerDay$shifts = workerDay.shifts) === null || _workerDay$shifts === void 0 ? void 0 : _workerDay$shifts.some(function (shift) {
        return !!shift.code;
      }));
    });
  });
}

function getSplitedToDates(daysWithData, daysWithoutData, destination) {
  var toClear = [];
  var toChange = [];

  if (daysWithData === 0) {
    toClear = destination;
  } else if (daysWithData >= destination.length) {
    toChange = destination;
  } else if (daysWithoutData) {
    toChange = _toConsumableArray(destination);
    toClear = destination.splice(0, daysWithoutData);
  } else {
    toChange = destination;
  }

  return {
    toClearDates: toClear,
    toChangeDates: toChange
  };
}